/* ================================================================
   Custom Cable + Custom Hydraulic Hose Cart Override  v3
   Handles BOTH the static cart page AND the ajax cart drawer.

   Cart page rows:      li / div.cart__row  (selector: .cart__row)
   Drawer rows:         li.ajaxcart__product  (selector: .ajaxcart__product)
   Detection in both:   a[href*="/products/custom-cable"]
                        a[href*="/products/custom-hydraulic-hose"]

   For each matched row:
     - Hide qty input  + +/- stepper buttons
     - Insert "Qty: 1 custom cable" or "Qty: 1 custom hose" static label
     - Mark row disabled so no accidental qty mutation
   ================================================================ */

(function () {
  'use strict';

  var HANDLE_SLUGS = [
    '/products/custom-cable',
    '/products/custom-hydraulic-hose'
  ];

  /* ---- Cart PAGE selectors ---- */
  var PAGE_ROW_SEL     = '.cart__row';
  var PAGE_QTY_SEL     = 'input[name^="updates"], .quantity-selector, input.cart-number, input.quantity-btn-number';
  var PAGE_MINUS_SEL   = '.qtyminus1, .quantity-btn-minus';
  var PAGE_PLUS_SEL    = '.qtyplus1, .quantity-btn-plus';

  /* ---- Drawer (ajax-cart) selectors ---- */
  var DRAWER_ROW_SEL   = '.ajaxcart__product';          /* <li class="ajaxcart__product â€¦"> */
  var DRAWER_QTY_SEL   = '.ajaxcart__qty-num';          /* <input class="ajaxcart__qty-num â€¦"> */
  var DRAWER_MINUS_SEL = '.ajaxcart__qty--minus';        /* <button class="â€¦ ajaxcart__qty--minus â€¦"> */
  var DRAWER_PLUS_SEL  = '.ajaxcart__qty--plus';         /* <button class="â€¦ ajaxcart__qty--plus â€¦"> */
  var DRAWER_QTY_WRAP  = '.ajaxcart__qty';               /* wrapper <div class="ajaxcart__qty â€¦"> */

  var LABEL_CLASS = 'cc-cart-qty-display';
  var DONE_CLASS  = 'cc-cart-processed';

  /* ---- Match row against any custom-product handle ---- */
  function getMatchedSlug(row) {
    for (var i = 0; i < HANDLE_SLUGS.length; i++) {
      if (row.querySelector('a[href*="' + HANDLE_SLUGS[i] + '"]')) {
        return HANDLE_SLUGS[i];
      }
    }
    return null;
  }

  /* ---- Friendly label based on which slug matched ---- */
  function getFriendlyLabel(slug) {
    if (slug && slug.indexOf('custom-hydraulic-hose') !== -1) {
      return 'Qty: 1 custom hose';
    }
    return 'Qty: 1 custom cable';
  }

  /* ---- Generic row patcher ---- */
  function patchRow(row, qtyInputSel, minusSel, plusSel, qtyWrapSel) {
    if (row.classList.contains(DONE_CLASS)) return;

    var matchedSlug = getMatchedSlug(row);
    if (!matchedSlug) return;

    row.classList.add(DONE_CLASS);
    var friendlyLabel = getFriendlyLabel(matchedSlug);

    /* Hide stepper buttons */
    var minus = row.querySelector(minusSel);
    var plus  = row.querySelector(plusSel);
    if (minus) { minus.style.cssText += ';display:none!important;pointer-events:none;'; }
    if (plus)  { plus.style.cssText  += ';display:none!important;pointer-events:none;'; }

    /* Hide qty input and insert static label */
    var qtyInput = row.querySelector(qtyInputSel);
    if (qtyInput) {
      qtyInput.style.cssText += ';display:none!important;';
      qtyInput.setAttribute('disabled', 'disabled');
      qtyInput.setAttribute('readonly', 'readonly');

      /* Insert static label before the input (or before the wrapper) */
      var insertTarget = qtyWrapSel ? (row.querySelector(qtyWrapSel) || qtyInput) : qtyInput;
      if (!insertTarget.parentNode.querySelector('.' + LABEL_CLASS)) {
        var label = document.createElement('span');
        label.className = LABEL_CLASS;
        label.textContent = friendlyLabel;
        label.style.cssText = 'font-weight:600;padding:6px 4px;display:inline-block;font-size:0.9em;color:inherit;';
        insertTarget.parentNode.insertBefore(label, insertTarget);
      }
    } else if (qtyWrapSel) {
      /* Fallback: hide the whole qty wrapper and inject label before it */
      var wrap = row.querySelector(qtyWrapSel);
      if (wrap) {
        wrap.style.cssText += ';display:none!important;';
        if (!wrap.parentNode.querySelector('.' + LABEL_CLASS)) {
          var label2 = document.createElement('span');
          label2.className = LABEL_CLASS;
          label2.textContent = friendlyLabel;
          label2.style.cssText = 'font-weight:600;padding:6px 4px;display:inline-block;font-size:0.9em;color:inherit;';
          wrap.parentNode.insertBefore(label2, wrap);
        }
      }
    }
  }

  /* ---- Apply to cart PAGE rows ---- */
  function applyPageOverride() {
    var rows = document.querySelectorAll(PAGE_ROW_SEL);
    rows.forEach(function (row) {
      patchRow(row, PAGE_QTY_SEL, PAGE_MINUS_SEL, PAGE_PLUS_SEL, null);
    });
  }

  /* ---- Apply to drawer rows ---- */
  function applyDrawerOverride() {
    var rows = document.querySelectorAll(DRAWER_ROW_SEL);
    rows.forEach(function (row) {
      patchRow(row, DRAWER_QTY_SEL, DRAWER_MINUS_SEL, DRAWER_PLUS_SEL, DRAWER_QTY_WRAP);
    });
  }

  /* ---- Apply to both ---- */
  function applyAll() {
    applyPageOverride();
    applyDrawerOverride();
  }

  /* ---- MutationObserver for #CartContainer (drawer re-renders here) ---- */
  function observeDrawer() {
    var drawerTarget = document.getElementById('CartContainer')
                    || document.getElementById('CartDrawer')
                    || document.body;

    var obs = new MutationObserver(function () {
      setTimeout(applyAll, 0);
    });
    obs.observe(drawerTarget, { childList: true, subtree: true });
  }

  /* ---- Hook into jQuery ajaxCart.afterCartLoad event ---- */
  function hookJQueryEvent() {
    document.addEventListener('ajaxCart.afterCartLoad', function () {
      setTimeout(applyAll, 50);
    });
    var tryJQ = function () {
      if (window.jQuery) {
        jQuery('body').on('ajaxCart.afterCartLoad', function () {
          setTimeout(applyAll, 50);
        });
      } else {
        setTimeout(tryJQ, 200);
      }
    };
    tryJQ();
  }

  /* ---- Also watch for the drawer element becoming visible ---- */
  function observeDrawerVisibility() {
    var drawer = document.getElementById('CartDrawer');
    if (!drawer) return;

    var visObs = new MutationObserver(function (mutations) {
      mutations.forEach(function (m) {
        if (m.type === 'attributes' || m.type === 'childList') {
          setTimeout(applyAll, 50);
        }
      });
    });
    visObs.observe(drawer, { attributes: true, attributeFilter: ['class', 'style'], childList: true, subtree: false });
  }

  /* ---- Boot ---- */
  function boot() {
    applyAll();

    document.addEventListener('cart:refresh', function () { setTimeout(applyAll, 50); });

    observeDrawer();
    observeDrawerVisibility();
    hookJQueryEvent();

    var sweepCount = 0;
    var sweep = setInterval(function () {
      applyAll();
      sweepCount++;
      if (sweepCount >= 20) clearInterval(sweep);
    }, 500);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

})();
